import { graphic } from "../../Graphic";
import { TYPES } from "../../EntityManager";

export class GraphicItemService {

    static findBySeatReference(seatReference) {
        let result = null;
        graphic.entityManager.forEach(TYPES.ROW, row => {
            if (row.isEnable) {
                row.graphicItems.forEach((graphicItem, index) => {
                    const seatLabel = row.sequence.labels[index].text;
                    const rowLabel = row.label.value;
                    if (rowLabel + '-' + seatLabel === seatReference) {
                        result = [row, graphicItem, index]
                    }
                });
            }
        });
        return result;
    }

    static findByPitId(pitId) {
        let result = null;
        graphic.entityManager.forEach(TYPES.PIT, pit => {
            if (pit.id === pitId) result = [pit, pit.graphicItems[0], 0];
        });
        return result;
    }

    static cibling(graphicItem) {
        graphic.setZoom({ value: 1 });

        const itemBounds = graphicItem.getBounds();
        const centerScreenPosition = graphic.withTransformContainer(graphic.parentCenter);
        const originPosition = graphic.withTransformContainer({x: 0, y: 0});
        const translation = {
            x: centerScreenPosition.x - (originPosition.x + (itemBounds.x + (itemBounds.width / 2) * graphic.zoom)),
            y: centerScreenPosition.y - (originPosition.y + (itemBounds.y + (itemBounds.height / 2) * graphic.zoom)),
        };
        graphic.translate(translation);
    }

    static setGraphicItemColor(graphicItem, color = null, alpha = null) {
        graphicItem.cacheAsBitmap = false;
        if (color) graphicItem.tint = parseInt(`0x${color.replace('#', '')}`);
        if (alpha) graphicItem.geometry.graphicsData[0].fillStyle.alpha = alpha;
        graphicItem.geometry.invalidate();
        graphicItem.cacheAsBitmap = true;
    }
}